import ajax from '../../../public/mobile/utils/ajax';
import proFetch from "../../../public/mobile/utils/project-fetch";
import proFetchNew from "../../../public/mobile/utils/project-fetchNew";
import getUrlParam from './getUrlParam';

export {ajax, proFetch, getUrlParam,proFetchNew}
